'use client'
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import useFormattedDate from "../../hooks/useFormattedDate.js";
import { cn } from "../../utils/cn.js";
import { IconButton } from "../IconButton/IconButton.js";
import { Image } from "../Image/Image.js";
import { P } from "../Text/P.js";
import { chatBubbleVariants } from "./ChatBubble.variants.js";
const USER = 'user';
const RESPONSE_BOLD = 'responseBold';
const THUMB_DOWN = 'thumb_down';
const THUMB_UP = 'thumb_up';
const SYNC = 'sync';
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/penny/smPennyOrb.svg';
function ChatBubble({ children, dateString, showResponseIcon = false, showVote = false, showSync = false, canToggleVote = true, onIconClick, slots = {
    wrapperSlot: '',
    containerSlot: '',
    contentSlot: '',
    responseIconSlot: '',
    footerSlot: ''
}, role }) {
    const { wrapperSlot, containerSlot, contentSlot, responseIconSlot, footerSlot } = chatBubbleVariants({
        role
    });
    const [thumbToggle, setThumbToggle] = useState();
    const slotClasses = {
        wrapperClasses: cn(wrapperSlot(), slots?.wrapperSlot),
        containerClasses: cn(containerSlot(), slots?.containerSlot),
        contentClasses: cn(contentSlot(), slots?.contentSlot),
        responseIconClasses: cn(responseIconSlot(), slots?.responseIconSlot),
        footerClasses: cn(footerSlot(), slots?.footerSlot)
    };
    const { wrapperClasses, containerClasses, contentClasses, responseIconClasses, footerClasses } = slotClasses;
    const handleVote = useCallback((vote)=>{
        if (void 0 === thumbToggle) {
            setThumbToggle(vote);
            onIconClick?.[vote]?.();
        } else if (canToggleVote) {
            setThumbToggle(vote === thumbToggle ? void 0 : vote);
            onIconClick?.[vote]?.();
        }
    }, [
        thumbToggle,
        setThumbToggle,
        onIconClick,
        canToggleVote
    ]);
    const formattedDate = useFormattedDate(dateString);
    const showFooter = showVote || showSync || dateString;
    return /*#__PURE__*/ jsxs("div", {
        className: wrapperClasses,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: containerClasses,
                "data-testid": "chat-bubble-content-container",
                children: [
                    role !== USER && showResponseIcon && /*#__PURE__*/ jsx(Image, {
                        alt: "Penny Logo",
                        height: 8,
                        className: responseIconClasses,
                        isSvg: true,
                        src: TRAVEL_BOT_LOGO
                    }),
                    /*#__PURE__*/ jsx("div", {
                        className: contentClasses,
                        children: children
                    })
                ]
            }),
            showFooter && /*#__PURE__*/ jsxs("div", {
                className: footerClasses,
                children: [
                    showVote && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            /*#__PURE__*/ jsx(IconButton, {
                                iconName: THUMB_UP,
                                type: "penny",
                                title: "helpful",
                                active: 'thumbsUp' === thumbToggle,
                                emphasis: role === RESPONSE_BOLD ? 'bold' : 'regular',
                                disabled: 'thumbsDown' === thumbToggle || !canToggleVote && !!thumbToggle,
                                size: "2xs",
                                onClick: ()=>handleVote('thumbsUp')
                            }),
                            /*#__PURE__*/ jsx(IconButton, {
                                iconName: THUMB_DOWN,
                                type: "penny",
                                title: "not helpful",
                                emphasis: role === RESPONSE_BOLD ? 'bold' : 'regular',
                                active: 'thumbsDown' === thumbToggle,
                                disabled: 'thumbsUp' === thumbToggle || !canToggleVote && !!thumbToggle,
                                size: "2xs",
                                onClick: ()=>handleVote('thumbsDown')
                            })
                        ]
                    }),
                    showSync && /*#__PURE__*/ jsx(IconButton, {
                        iconName: SYNC,
                        type: "penny",
                        emphasis: role === RESPONSE_BOLD ? 'bold' : 'regular',
                        size: "2xs",
                        onClick: onIconClick?.sync
                    }),
                    dateString && /*#__PURE__*/ jsx(P, {
                        children: formattedDate
                    })
                ]
            })
        ]
    });
}
export { ChatBubble };
